import React from 'react';
import { Link } from 'react-router-dom';
import BirdMascot from './BirdMascot';

const Footer = () => {
  return (
    <footer className="border-t border-border bg-card/50 backdrop-blur-sm py-10 mt-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <BirdMascot size={28} />
              <span className="text-lg font-heading font-bold">JailBirds</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Test your detective instincts with real mugshots from Mecklenburg County, NC.
            </p>
          </div>

          {/* Game */}
          <div>
            <h4 className="font-semibold mb-3">Game</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/how-to-play" className="text-muted-foreground hover:text-primary transition-colors">
                  How to Play
                </Link>
              </li>
              <li>
                <Link to="/leaderboard" className="text-muted-foreground hover:text-primary transition-colors">
                  Leaderboard
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-3">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/legal" className="text-muted-foreground hover:text-primary transition-colors">
                  Legal Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-border pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground text-center sm:text-left">
            © 2025 JailBirds. Owned and operated by M.Panepinto. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <a href="mailto:support@jailbirdsgame.com" className="hover:text-primary transition-colors">
              support@jailbirdsgame.com
            </a>
            <Link to="/rta" className="hover:text-primary transition-colors opacity-50" title="Admin Analytics">
              RTA
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
